



























































































































































































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';

import bButton from 'bootstrap-vue/es/components/button/button';
import bCol from 'bootstrap-vue/es/components/layout/col';
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
import bFormRadio from 'bootstrap-vue/es/components/form-radio/form-radio';
import bFormRadioGroup from 'bootstrap-vue/es/components/form-radio/form-radio-group';
import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select';
import bLink from 'bootstrap-vue/es/components/link/link';
import bRow from 'bootstrap-vue/es/components/layout/row';

import PriceBlock from '@/components/PriceBlock.vue';

import {
  Address,
  DraftFulfillment,
  FulfillmentService,
} from '@/models';
import { formatAddress } from '@/lib/address';

const FulfillmentSelectionFormProps = Vue.extend({
  props: {
    fulfillment: {
      type: DraftFulfillment,
      required: true,
    },
  },
});

@Component({
  components: {
    FontAwesomeIcon,
    PriceBlock,

    bButton,
    bCol,
    bFormGroup,
    bFormInput,
    bFormRadio,
    bFormRadioGroup,
    bFormSelect,
    bLink,
    bRow,
  },
})
export default class FulfillmentSelectionForm extends FulfillmentSelectionFormProps {
  public readonly faPlus = faPlus;
  public readonly faArrowLeft = faArrowLeft;

  public selected = this.fulfillment.service.id;
  public selectedAddress = this.fulfillment.shippingAddress;

  public showShippingForm = false;

  // Shipping address form data
  public shippingAddressCity: string | null = null;

  public isSelected(option: { service: FulfillmentService }) {
    return option.service.id === this.selected;
  }

  public formatAddress(address: Address) {
    return formatAddress(address);
  }

  public selectFulfillment(option: {
    service: FulfillmentService,
    addresses: Address[],
  }) {
    if (this.selected !== option.service.id) {
      this.selected = option.service.id;
      if (option.service === this.fulfillment.service) {
        this.selectedAddress = this.fulfillment.shippingAddress;
      } else if (option.addresses.length > 0) {
        this.selectedAddress = option.addresses[0];
      } else {
        this.selectedAddress = undefined;
      }
    }
  }

  public addShippingAddress() {
    this.showShippingForm = true;
  }
}

